/**
 * Currency formatting - abbreviated for dashboard displays
 */
export function formatCurrency(amount) {
    if (amount === null || amount === undefined)
        return '$0';
    if (amount >= 10000) {
        return '$' + (amount / 1000).toFixed(1) + 'k';
    }
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(amount);
}
/**
 * Currency formatting - full precision with cents
 */
export function formatCurrencyFull(amount) {
    if (amount === null || amount === undefined)
        return '$0.00';
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(amount);
}
/**
 * Relative date formatting ("Today", "2 days ago", "Jan 15")
 */
const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
function parseDate(dateString) {
    const dateOnly = DATE_ONLY_PATTERN.exec(dateString);
    if (dateOnly) {
        const [, year, month, day] = dateOnly;
        return new Date(Number(year), Number(month) - 1, Number(day));
    }
    return new Date(dateString);
}
function localCalendarDay(date) {
    return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
}
export function formatDate(dateString) {
    if (!dateString)
        return 'N/A';
    const date = parseDate(dateString);
    const now = new Date();
    // Relative labels describe local calendar dates, not elapsed 24-hour blocks.
    // Local midnights can be 23 or 25 hours apart across DST boundaries, so map
    // each local Y/M/D to a UTC day number before subtracting.
    const diffDays = Math.round((localCalendarDay(now) - localCalendarDay(date)) / (1000 * 60 * 60 * 24));
    if (diffDays < 0) {
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
        });
    }
    if (diffDays === 0)
        return 'Today';
    if (diffDays === 1)
        return 'Yesterday';
    if (diffDays < 7)
        return `${diffDays} days ago`;
    return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
    });
}
/**
 * Full date formatting (MM/DD/YYYY)
 */
export function formatDateFull(dateString) {
    if (!dateString)
        return 'N/A';
    const date = parseDate(dateString);
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
}
/**
 * Full date + time formatting (MM/DD/YYYY, h:mm AM/PM)
 *
 * Used where ordering of same-day events matters (e.g. the ticket history
 * timeline), so create/save/submit on one day stay distinguishable.
 */
export function formatDateTime(dateString) {
    if (!dateString)
        return 'N/A';
    const date = parseDate(dateString);
    return date.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: 'numeric',
        minute: '2-digit',
    });
}
/**
 * Hours formatting ("5h")
 */
export function formatHours(hours) {
    if (!hours)
        return '0h';
    return `${hours}h`;
}
//# sourceMappingURL=format.js.map